import { render, staticRenderFns } from "./EditFollowingProduction.vue?vue&type=template&id=48204eb1&scoped=true&"
import script from "./EditFollowingProduction.vue?vue&type=script&lang=js&"
export * from "./EditFollowingProduction.vue?vue&type=script&lang=js&"
import style0 from "./EditFollowingProduction.vue?vue&type=style&index=0&id=48204eb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48204eb1",
  null
  
)

export default component.exports